import { REACT_APP_LOCALES } from '../config';

export const supportedLocale = REACT_APP_LOCALES && REACT_APP_LOCALES.split(',');

// Master list of available translation files
export const masterLanguageList = {
  'en-US': 'English (US)',
  'en-CA': 'English (CA)',
  'en-GB': 'English (UK)',
  'bg-BG': 'Bulgarian',
  'cs-CS': 'Czech',
  'da-DK': 'Danish',
  'de-DE': 'German',
  'el-GR': 'Greek',
  'es-ES': 'Spanish (ES)',
  'es-MX': 'Spanish (MX)',
  'et-ET': 'Estonian',
  'fi-FI': 'Finnish',
  'fr-CA': 'French (CA)',
  'fr-FR': 'French (FR)',
  'hu-HU': 'Hungarian',
  'it-IT': 'Italian',
  'lt-LT': 'Lithuanian',
  'lv-LV': 'Latvian',
  'nl-NL': 'Dutch',
  'no-NO': 'Norwegian',
  'pl-PL': 'Polish',
  'pt-PT': 'Portuguese',
  'ro-RO': 'Romanian',
  'sk-SK': 'Slovak',
  'sl-SL': 'Slovenian',
  'sv-SE': 'Swedish',
  'zh-CN': 'Chinese (Traditional)',
};

// This will filter master list with REACT_APP_LOCALES list
// If no supportedLocale, default to master list
export const localeToLngName = supportedLocale.reduce((obj, key) => ({ ...obj, [key]: masterLanguageList[key] }), {});

// Reverse of localeToLngName for UI mapping
export const lngNameToLocale = Object.fromEntries(Object.entries(localeToLngName).map(([k, v]) => [v, k]));

// Translation files are based on locale code
// This is used for mapppig lng code back to locale
export const lngCodeToLocale = {
  bg: 'bg-BG',
  cs: 'cs-CS',
  da: 'da-DK',
  de: 'de-DE',
  ek: 'el-GR',
  en: 'en-US',
  es: 'es-ES',
  et: 'et-ET',
  fi: 'fi-FI',
  fr: 'fr-FR',
  hu: 'hu-HU',
  it: 'it-IT',
  lt: 'lt-LT',
  lv: 'lv-LV',
  nl: 'nl-NL',
  no: 'no-NO',
  pl: 'pl-PL',
  pt: 'pt-PT',
  ro: 'ro-RO',
  sk: 'sk-SK',
  sl: 'sl-SL',
  sv: 'sv-SE',
  zh: 'zh-CN',
};
